//dependencias
import React, { Component } from 'react';

//componentes
import Clientes from './clientes';
class Index extends Component {
    render() {
        return(
            <div className="Inicio">
                <Clientes /> 
            </div>
        );
    }
}
export default Index;